<template>
  <div>
    <input-multiselect v-model="model" :options="papeis" label="Papéis" :required="!nomeConjuge" :disabled="!!nomeConjuge || bloquearEdicaoPapel" />
  </div>
</template>
<script>
export default {
  props: {
    codigoProposta: String,
    value: [],
    assinante: Object,
    nomeConjuge: String,
    documentoConjuge: String,
    cliente: Object,
    bloquearEdicaoPapel: { type: Boolean, default: false }
  },
  data () {
    return {
      listBase: []
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    papeis: {
      get () {
        return this.$param.EST_PAPEIS.map(el => {
          const tipo = this.$api.UI.Format.SomenteNumeros(this.cliente.DocumentoFederal).length === 11 ? 'pf' : 'pj'
          if (el[tipo]) {
            return {
              text: el.tipo === this.$aux.PapelAssinaturaEnum.Avalista ? 'AVALISTA' : el.papel.replace('@EMITENTENOME', this.cliente?.Nome).replace('@REPRESENTANTEDOCUMENTO', this.cliente?.DocumentoFederal),
              value: { Descricao: el.papel.replace('@EMITENTENOME', this.cliente?.Nome).replace('@REPRESENTANTEDOCUMENTO', this.cliente?.DocumentoFederal), PapelID: el.tipo },
            }
          }
        })
      },
      set () {
        return this.$param.EST_PAPEIS;
      }
    },
  },
  methods: {
    async submit () {
      const th = this;

      var arrayInclusao = Array.isArray(th.model) ? [...th.model] : [];

      if (arrayInclusao.length > 0) {
        const assinante = th.assinante
        th.$api.Multiplo.FindRecordProdutoRede().then(function (res) {
          arrayInclusao = arrayInclusao.map(papel => {
            return {
              CodigoProposta: th.codigoProposta,
              Nome: assinante.Nome,
              Email: assinante.Email,
              Documento: assinante.DocumentoFederal,
              TelefoneCelular: assinante.TelefoneCelular,
              Descricao: th.nomeConjuge ? `${papel.Descricao} - CÔNJUGE DE ${th.nomeConjuge} ${th.documentoConjuge}` : papel.Descricao,
              PapelID: papel.PapelID === th.$aux.PapelAssinaturaEnum.Avalista ? papel.PapelID : null,
              NotificarPorEmail: th.$aux.NotificaPorEmail.includes(res.ModeloNotificacaoAssinatura),
              NotificarPorWhatsApp: th.$aux.NotificaPorWhatsApp.includes(res.ModeloNotificacaoAssinatura)
            }
          })
          th.$api.Multiplo.InsertCCBDigitalAssinaturas({ dto: arrayInclusao }).then(resInsert => {
            if (th.$api.UI.PostLoadData(resInsert, true)) { };
          });
        })
      }
    },
    carregarAssinantes () {
      const th = this;
      const dtoAssinantes = {
        parameters: [
          { name: 'CodigoProposta', value: th.codigoProposta },
          { name: 'search', value: '' },
        ],
      };

      th.$api.Multiplo.ListCCBDigitalAssinatura(dtoAssinantes).then(assinantes => {
        if (th.$api.UI.PostLoadData(assinantes)) {
          th.$set(th, 'listBase', assinantes.Data.filter(el => th.$api.UI.Format.SomenteAlfanumerico(el.Documento) === th.$api.UI.Format.SomenteAlfanumerico(th.assinante.DocumentoFederal)));
          th.model = th.listBase.map((item) => {
            if (item.Descricao.includes('AVALISTA')) {
              const papel = th.papeis.find(papel => item.Descricao.includes(papel?.value.Descricao.split('-')[0]))
              return papel ? papel.value : null
            } else {
              const papel = th.papeis.find(papel => item.Descricao.includes(papel?.value.Descricao.split('-')[0]) && item.Descricao.includes(th.cliente.DocumentoFederal))
              return papel ? papel.value : null
            }
          });
        }
      });
    },
  },
}
</script>
<style scoped>
</style>
